// extracted by mini-css-extract-plugin
export var actionButton = "_bc-1";
export var actionButtons = "_bc-2";
export var actions = "_bc-0";
export var aiUnread = "_bc-10";
export var alignCenter = "_bc-h";
export var backWrapper = "_bc-3";
export var cellContainer = "_bc-4";
export var checkboxContainer = "_bc-5";
export var contentContainer = "_bc-6";
export var contentHeader = "_bc-8";
export var conversationsTableWrapper = "_bc-s";
export var draftReplyBadgeContainer = "_bc-m";
export var dropdownItem = "_bc-b";
export var dropdownItemsContainer = "_bc-a";
export var dropdownTitle = "_bc-c";
export var errorIcon = "_bc-7";
export var filter = "_bc-d";
export var gray = "_bc-i";
export var headerActionButtons = "_bc-e";
export var headerCheckboxContainer = "_bc-f";
export var icon = "_bc-j";
export var menuContainer = "_bc-k";
export var noMoreTicketsIcon = "_bc-12";
export var noMoreTicketsSubText = "_bc-13";
export var oneLine = "_bc-l";
export var optionsButton = "_bc-n";
export var plus = "_bc-o";
export var portalButtonsWrapper = "_bc-g";
export var red = "_bc-p";
export var scrolledTop = "_bc-9";
export var search = "_bc-q";
export var selectedConversationsCount = "_bc-r";
export var spinner = "_bc-t";
export var strong = "_bc-u";
export var summaryCell = "_bc-v";
export var tableContainer = "_bc-11";
export var tagContainer = "_bc-w";
export var threeDots = "_bc-x";
export var twoLines = "_bc-y";
export var unread = "_bc-z";